// pages/About.js
import React from 'react';
import { Award, Users, TrendingUp, Shield, CheckCircle, MapPin } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Award,
      title: 'Quality Excellence',
      description: 'Committed to delivering the highest quality electrical solutions.'
    },
    {
      icon: Users,
      title: 'Customer Focus',
      description: 'Putting our clients first in everything we do.'
    },
    {
      icon: TrendingUp,
      title: 'Innovation',
      description: 'Embracing new technologies for better solutions.'
    },
    {
      icon: Shield,
      title: 'Safety First',
      description: 'Uncompromising commitment to safety standards.'
    }
  ];

  return (
    <div className="pt-20">
      <section className="relative py-20 bg-gradient-to-r from-[#006D77] to-[#008B8B] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff20_1px,transparent_1px),linear-gradient(to_bottom,#ffffff20_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
        </div>
        <div className="container mx-auto px-4 md:px-6 text-center relative">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold mb-4 tracking-tight">About Linear Power Systems</h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-light">
            Engineering electrical excellence for reliable power systems across Kenya and East Africa
          </p>
          <div className="flex flex-wrap justify-center gap-6 mt-6 text-white/80">
            <span className="flex items-center gap-2">
              <MapPin size={18} />
              Nairobi, Kenya
            </span>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 md:px-6 max-w-5xl">
          <div className="bg-gray-50 rounded-2xl p-8 md:p-10 mb-12 text-center border border-gray-100">
            <p className="text-2xl md:text-3xl font-bold text-gray-900 leading-relaxed">
              We are an electrical engineering company based in Nairobi, Kenya, 
              specializing in panel building, VFD installations, and complete electrical solutions.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-sm border-l-4 border-[#006D77]">
              <h3 className="text-2xl font-extrabold text-gray-900 mb-4 tracking-tight">Our Mission</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                To deliver reliable, innovative, and sustainable electrical solutions that power 
                Africa's growth and development.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-sm border-l-4 border-[#008B8B]">
              <h3 className="text-2xl font-extrabold text-gray-900 mb-4 tracking-tight">Our Vision</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                To be a premier electrical engineering partner in East Africa, known for excellence, 
                integrity, and innovation.
              </p>
            </div>
          </div>

          <h2 className="text-4xl font-extrabold text-gray-900 mb-8 text-center tracking-tight">Our Core <span className="text-[#006D77]">Values</span></h2>
          <div className="grid md:grid-cols-4 gap-6">
            {values.map((value, idx) => {
              const Icon = value.icon;
              return (
                <div key={idx} className="text-center p-6 bg-white rounded-2xl shadow-sm border border-gray-100 hover:shadow-lg transition-all hover:-translate-y-1">
                  <div className="w-16 h-16 bg-[#006D77]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8 text-[#006D77]" />
                  </div>
                  <h4 className="font-extrabold text-gray-900 text-lg tracking-tight">{value.title}</h4>
                  <p className="text-sm text-gray-500 mt-2">{value.description}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-12 bg-[#006D77]/5 rounded-2xl p-8 text-center border border-[#006D77]/10">
            <CheckCircle className="w-12 h-12 text-[#006D77] mx-auto mb-4" />
            <p className="text-lg text-gray-700 font-medium">
              Delivering innovative electrical solutions across Kenya
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
